<div class="page-content" *ngIf="parentIndex < parentCount && !timerService.isForwarding">

      <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>
 
      <h1 class="page-title">
               <span class="title-class" translate='parentScreen.page_title' [translateParams]="parentParam"></span>
      </h1>

      <div class="bottom-1" [if]="parentIndex==0?(isSurrogate?'P':'B'):'N'" html='parentScreen.intro_birthParent$'></div>
 

      <form>
      <!--   Parent Title   -->
      <h2 translate='parentScreen.parent_title.label' style="display:inline-block"></h2>
      <span [hidden]="!isCustodyOtherThanParent||parent.isGiveBirth=='Y'" translate>{{'-text.optional'}}</span>
      <br/>
      
      <div style="margin-left:0.5em; margin-top:0.5em; margin-bottom:0" id='parenTitle'>

            <div html='parentScreen.parent_title.whichParent' [param]="parentParam"></div>

            <accordion label='-accord.whatThisMean' margin="0.5">
                  <div html='parentScreen.parent_title.accord_whatThisMean'></div>
                  <div style="padding-top:1em;" html='parentScreen.parent_title.accord_whatThisMean2'></div>
            </accordion>
            <fieldset>
            <legend><span translate='parentScreen.parent_title.label' class="sr-only"></span></legend>
            <ng-radio1 [(ng-model)]="parent.parentType" id="parentTypeRadio_0" 
                       [(ng-clear)]="error_parentType"  value="1"
                         label='parentScreen.parent_title.mother'></ng-radio1>

                        <div class="parent-title-accord"  
                              [hidden]="parent.parentType!=1 || parentIndex==0 || isSurrogate"
                               translate='parentScreen.parent_title.whyMother'>
                        </div>

            <ng-radio1 [(ng-model)]="parent.parentType" 
                       [(ng-clear)]="error_parentType"  value="2"
                         label='parentScreen.parent_title.father'></ng-radio1>

                        <div class="parent-title-accord"  
                              [hidden]="parent.parentType!=2 || parentIndex > 0 || isSurrogate"
                             translate='parentScreen.parent_title.whyFather'>
                        </div>

            <ng-radio1 [(ng-model)]="parent.parentType" 
                       [(ng-clear)]="error_parentType"  value="3"
                         label='parentScreen.parent_title.parent'></ng-radio1>

                      <div class="parent-title-accord"  
                           [hidden]="parent.parentType!=3 || parentIndex>0 || isSurrogate"
                           translate='parentScreen.parent_title.whyParentB'>
                      </div>

                      <div class="parent-title-accord"  
                           [hidden]="parent.parentType!=3 || parentIndex==0 || isSurrogate"
                          translate='parentScreen.parent_title.whyParentN'>
                      </div>
            </fieldset>
      </div>
      <errors [error]="error_parentType" [if]="isBirthParent"></errors>           
 

      <!-- birth mother only -->
      <div [hidden]="!isBirthParent && ( !isSurrogate || parentIndex > 0 )" style="margin-top:1.5em;" id="maritalStatus">
               
              <!--   What was the marital status?  -->
              <ng-select [item-list]="items.maritalStatus"  size="10" id="maritalStatusSelect"
                         [(ng-model)]="parent.maritalStatus"
                         [(ng-error)]="error_maritalStatus"
                          [error-if]="isBirthParent"
                           label='parentScreen.maritalStatus.label'
                          [label-param]="parentParam">
                          <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
              </ng-select>
       </div>
              
       <div [hidden]="!isBirthParent" style="margin-top:0.5em; margin-bottom:1.8em" id="pregnancyInfo">
                  <!--    Duration of Pregnancy   -->
              <div translate>{{'parentScreen.pregnancy.duration'}}
                  <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
              </div>    
              
              <ng-input type="number"  size="4" max="2" margin="0/0.5"  space="3em"
                        [(ng-model)]="parent.pregnancyDuration" id="pregnancyDuration"
                        [(ng-error)]="error_pregnancyDuration"
                            alt-text='parentScreen.pregnancy.alt'>
              <span translate='parentScreen.pregnancy.duration' class="sr-only"></span>  
              </ng-input>  
 
              <accordion label="-accord.noIdea">
                             {{'parentScreen.pregnancy.noIdeaDuration'}}
              </accordion>

              <br/>

              <!-- previously given birth to any children, liveborn or stillborn?  -->
              <div id="previousBorn" [hidden]="data.subject.index > 1">

                  <ng-radio [item-list]="items.yesNoList" id="previousBornRadio"
                            [(ng-model)]="parent.isPreviousBirth"
                            [(ng-error)]="error_previousBirth"
                             label='parentScreen.previousBirth.label'
                            [label-param]='parentParam'>
                            <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
                  </ng-radio>
      
                  <div [hidden]="parent.isPreviousBirth!='Y'" style="margin-left:2.2em">
              
                              <!--  How many liveborn children?  -->
                              <ng-input [(ng-model)]="parent.howManyLiveborn" type="number" size="4" max="2"  margin="0/0.5" id="liveBorn"
                                        [(ng-error)]="error_howManyLiveBorn"
                                       alt-text='parentScreen.previousBirth.howManyLiveborn_alt'
                                          label='parentScreen.previousBirth.howManyLiveborn'
                                         [label-param]="parentParam"></ng-input>
      
                              <!-- How many stillborn children?  -->
                              <ng-input [(ng-model)]="parent.howManyStillborn" type="number" size="4" max="2" id="stillBorn" 
                                        [(ng-error)]="error_howManyStillBorn"
                                       alt-text='parentScreen.previousBirth.howManyStillborn_alt'
                                          label='parentScreen.previousBirth.howManyStillborn'
                                         [label-param]="parentParam">
                              </ng-input>
      
                              <accordion label="-accord.whyYouAsk">
                                       <div translate='parentScreen.previousBirth.accord_whyYouAsk_text'></div>
                              </accordion>
                  </div>
              </div>
      </div>


      <!--  When was this parent born?   -->
      <div id="whenParentBorn" style="margin-top:2em">
            <ng-date [(ng-model)]="parent.whenParentBorn" body-style="margin-left:0.5em" id="whenParentBornBD"
                     [(ng-error)]="error_whenParentBorn"
                      [error-if]="isBirthParent"
                       alt-year='parentScreen.whenParentBorn.alt_year'
                       [months]="items.monthList">
                       <h2 translate='parentScreen.whenParentBorn.label' style="display:inline-block"></h2>
                       <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
            </ng-date>
      </div>


      <!-- Did this parent have a different Last Name? -->
      <div id="lastNameAtBirth" style="margin-top:2.5em">
      <fieldset>
           <legend>
           <span>
               <span [if]="isSingleName" html='parentScreen.atBirth.differentLast_single$'></span>
               <span [hidden]="!parentYear">{{'parentScreen.atBirth.differentLast_in'|translate}} {{parentYear}})</span>
               <span [hidden]="!isCustodyOtherThanParent||parent.isGiveBirth=='Y'" translate>{{'-text.optional'}}</span>
           </span>  
           </legend>
           <div class="hint-text" translate='parentScreen.atBirth.hint'></div>

           <ng-radio1 [(ng-model)]="parent.isOtherLastNameAtBirth" value="Y"  id="lastNameAtBirthRadio_0"
                      [(ng-clear)]="error_lastNameAtBirth"  
                       input-style="margin-left:0.5em">
                       <span [if]="isSingleName" html='parentScreen.atBirth.YesDifferent_single$'></span>
           </ng-radio1>  

           <ng-radio1 [(ng-model)]="parent.isOtherLastNameAtBirth" value="N" 
                      [(ng-clear)]="error_lastNameAtBirth"  
                      (change) = "resetOtherLastNameAtBirth(parent)"
                      input-style="margin-left:0.5em">
                        <span [if]="isSingleName" html='parentScreen.atBirth.NoSame_single$'></span>
           </ng-radio1>  

           <errors [if]="isSingleName"  [error]="error_lastNameAtBirth"></errors>           
      </fieldset>
           <!--  Last Name when this parent was born  -->
           <ng-input [hidden]="parent.isOtherLastNameAtBirth!='Y'"  size=50 outer-style="margin:0 0 1em 2em"
                     [(ng-model)]="parent.lastNameAtBirth"          alt-text='parentScreen.birthName.alt_single$' 
                     [(ng-error)]="error_birthNameInput"          [error-if]="isSingleName" id="lastNameAtBirthInput"
                     label='parentScreen.birthName.label_single$' [if]="hasSingleName">   
           </ng-input>
      
      </div>
 

      <!-- Did this parent ever use any other Last Name(s)? -->
      <div style="margin-top:2em" id="otherLastName">
              <ng-radio [(ng-model)]="parent.isOtherPreviousName" [item-list]="items.yesNoList" id="otherLastNameRadio"
                        [(ng-error)]="error_otherLastName"         input-style="margin-left:0.5em"
                        (change) = "resetOtherPreviousName(parent)"
                          [error-if]="isSingleName"> 

                    <span html='parentScreen.otherLastName.everUsed_single$' [if]="isSingleName"  ></span>
                    <span [hidden]="!isCustodyOtherThanParent||parent.isGiveBirth=='Y'" translate>{{'-text.optional'}}</span>
              </ng-radio>

              <!--  Enter any other Last Name(s) -->
              <ng-input [hidden]="parent.isOtherPreviousName!='Y'"  size=50 outer-style="margin:0.2em 0 1em 2em"
                        [(ng-model)]="parent.previousLastName"       alt-text='parentScreen.previousName.alt_single$' 
                        [(ng-error)]="error_prevNameInput"               [if]="isSingleName" id="otherLastNameInput"
                        label='parentScreen.previousName.label_single$'> 
              </ng-input>
      </div>


      <!--  Where was this parent born?  -->
      <h2 translate='parentScreen.whereParentBorn' style="margin-top:1.5em; display:inline-block"></h2>
      <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
      <div style="margin-left:0.5em" id="whereParentBorn">

              <!--  City/Town/Village -->
              <ng-input [(ng-model)]="parent.placeOfBirth.city"  size="40" max="50" id="cityInput"
                        [(ng-error)]="error_city"     [error-if]="isBirthParent"
                            alt-text='parentScreen.city.alt' 
                               label='parentScreen.city.label'></ng-input>

              <!--   Province  -->                                
              <ng-select [item-list]="items.provinceList"   size="22.5" id="provinceSelect"
                         [(ng-model)]="parent.placeOfBirth.province" 
                         [(ng-error)]="error_province"   [error-if]="isBirthParent"
                             (change)="onProvinceChange()"
                                label='parentScreen.province.label'></ng-select>

              <!--    Country   -->                                  
              <ng-select [item-list]="items.countryList"    size="29" id="countrySelect"
                         [(ng-model)]="parent.placeOfBirth.country" 
                         [(ng-error)]="error_country"  [error-if]="isBirthParent"
                             (change)="onCountrySelected()"
                                label='parentScreen.country.label'></ng-select>


              <!--   Other Country  -->                  
              <div [hidden]="parent.placeOfBirth.country!=NotFound">

                   <ng-input  id="otherCountry"
                              [(ng-model)]="parent.placeOfBirth.otherCountry"  size="40" max="40" 
                              [(ng-error)]="error_otherCountry"     [error-if]="isBirthParent"
                                alt-text='parentScreen.otherCountry.alt'>

                              <div translate='parentScreen.otherCountry.label' style="margin:0.5em 0"></div>
                              <div html='parentScreen.otherCountry.sub_heading1' class='hint-note' style="margin-bottom:0.5em"></div> 
                              <div html='parentScreen.otherCountry.sub_heading2' class='hint-note'></div> 
                              </ng-input>
              </div>                
              

      </div>

      </form>


      <!--   Continue Button -->
      <div class="btn-div">
           <div ><button class="btn-next" [alt-text]="Button.Next_alt" 
                        (click)="onNextClick()" translate>{{Button.Next}}</button></div>
      </div>
 
 </div>
 